import { call, put, takeEvery } from "redux-saga/effects";

import {
  GET_CANDIDATE_HIRE,
  GET_CLIENT_JOBS,
  GET_DASHBOARD_CARDS_DATA, GET_DASHBOARD_TOTALINTERVIEW_DATA,
  GET_JOBSTATUS_SUGGESTIONS,
  GET_JOB_COMPLETION_STATUS,
  GET_JOB_STATUS_DATA,
  GET_JOB_STATUS_FILTER_DATA,
  GET_NEW_CANDIDATES_DATA,
  GET_PUBLISHED_JOBS, GET_RECRUITMENT_DATA,
  GET_RECRUITMENT_REPORT,
  GET_UPCOMING_INTERVIEWS_DATA,
  GET_UPCOMING_INTERVIEWS_FILTER_DATA,
  GET_UPCOMING_INTERVIEW_SUGGESTIONS,
  GET_UPDATE_INTERVIEW
} from './actionTypes';


import {
  getCandidateHiredFail,
  getCandidateHiredSuccess,
  getClientJobsFail,
  getClientJobsSuccess,
  getDashboardCardsDataFailed,
  getDashboardCardsDataSuccess,
  getDashboardTotalTnterviewDataFailed,
  getDashboardTotalTnterviewDataSuccess,
  getJobComplitionStatusFailed,
  getJobComplitionStatusSuccessFull,
  getJobStatusSuggestionsFail,
  getJobStatusSuggestionsSuccess,
  getJobsStatusDataFailed,
  getJobsStatusDataSuccessFull,
  getNewCandidatesDataFailed, getNewCandidatesDataSuccess,
  getPublishedJobsDataFailed,
  getPublishedJobsDataSuccessFull,
  getRecruitmentDataFailed,
  getRecruitmentDataSuccessFull,
  getRecruitmentReportFailed,
  getRecruitmentReportSuccess,
  getUpComingInterviewsDataFailed,
  getUpComingInterviewsDataSuccessFull,
  getUpcomingInterviewsSuggestionsFail,
  getUpcomingInterviewsSuggestionsSuccess,
  updateInterviewFail,
  updateInterviewScuccess
} from './actions';

import {
  getDashboardCardsData, getDashboardTopCardData,
  getJobCompletion,
  getPublishedJobList, getRecruitmentAnalyticsData,
  getRecruitmentReport,
  getRequest,
  getUpcomingInterviews, postNewInterviewDetails
} from "../../../../../helpers/fakebackend_helper";


import * as constClass from "../../../../../common/constant/constantURL";


function* getPublishedJobsHandler({payload:{customJSON}}) {
    try 
    { 
      var url= constClass.REST_API_GET_PUBLISHED_JOBS; 
      var responsJSON = yield call(getPublishedJobList, url+"/"+customJSON.page+"?reportType="+customJSON.type);
      yield put(getPublishedJobsDataSuccessFull(responsJSON))
       } 
    catch (error) 
    {
      yield put(getPublishedJobsDataFailed(responsJSON))
    }
  }

  function* getRecruitmentHandler() {
    try 
    {
      var url= constClass.REST_API_GET_RECRUITMENT_DATA;
      var responsJSON = yield call(getRecruitmentAnalyticsData, url);
      yield put( getRecruitmentDataSuccessFull(responsJSON))
       } 
    catch (error) 
    {
      yield put(getRecruitmentDataFailed(responsJSON))
    }
  }

  function* getDashboardCardsHandler() {
    try 
    {
      var url= constClass.REST_API_GET_DASHBOARD_CARDS_DATA; 
      var responsJSON = yield call(getDashboardCardsData, url);
      yield put( getDashboardCardsDataSuccess(responsJSON))
       } 
    catch (error) 
    {
      yield put(getDashboardCardsDataFailed(responsJSON))
    }
  }  

  function* getDashboardTotalTnterviewHandler() {
    
    try{
        var url= constClass.REST_API_GET_DASHBOARD_TOTALINTERVIEW_DATA;
        var responseJSON = yield call(getRequest, url);
        yield put(getDashboardTotalTnterviewDataSuccess(responseJSON))
    }
    catch (error)
    {
      yield put(getDashboardTotalTnterviewDataFailed(error))
    }
  }

  
  function* getDashboardTopCard({payload:{tempData}}) {
    try 
    {
      var url= constClass.REST_API_GET_NEW_CANDIDATE_DATA ; 
      var responsJSON = yield call( getDashboardTopCardData, url+tempData);
      yield put(getNewCandidatesDataSuccess(responsJSON))
       } 
    catch (error) 
    {
      yield put(getNewCandidatesDataFailed(responsJSON))
    }
  }  

  //RecruitmentReport
  function* getRecruitmentReportHandler() {
    try 
    {
      var url= constClass.REST_API_GET_RECRUITMENT_REPORT;
      var responsJSON = yield call( getRecruitmentReport, url);
      yield put( getRecruitmentReportSuccess(responsJSON))
       } 
    catch (error) 
    {
      yield put(getRecruitmentReportFailed(responsJSON))
    }
  }
  
 //new dashboard
 function*  getJobsStatusHandler({payload:{jsondata}}) {

  let pageNumeber = 0
  let pageSize = 5

  if(jsondata != undefined && jsondata != null){
    pageNumeber = jsondata.pageNumber ? jsondata.pageNumber : 0
    pageSize  = jsondata.pageSize ?  jsondata.pageSize: 5
  }
  

  try 
  { 
    let url =  jsondata.searchKeyword !==null  && jsondata.searchKeyword !== undefined ? constClass.REST_API_GET_DB_SEARCH_JOB_STATUS: constClass.REST_API_GET_DB_JOB_STATUS

     url= url+`?page=${pageNumeber}&pageSize=${pageSize}`;
    
    if (jsondata.sort !==null  && jsondata.sort !== undefined){
      url= url+"&sort="+encodeURIComponent(jsondata.sort)
    }

    if (jsondata.searchKeyword !==null  && jsondata.searchKeyword !== undefined){
      url= url+"&searchKeyword="+(jsondata.searchKeyword)
    }
     
    let responsJSON = yield call( getJobCompletion, url);
    yield put(getJobsStatusDataSuccessFull(responsJSON))
     } 
  catch (error) 
  {
    yield put(getJobsStatusDataFailed(error))
  }
} 



function*  getJobsStatusFilterHandler({payload:{jsonData}}) {

  try 
  { 

    let url= constClass.REST_API_GET_DB_FILTER_JOB_STATUS+`?page=${jsonData.pageNumber}&pageSize=${jsonData.pageSize}&`; 

    if (jsonData.sort !==null){
     url= url+"sort="+encodeURIComponent(jsonData.sort)+"&"
   }
   let extentedUrl=jsonData.filter.map(eachObject=>{
     return eachObject.filterName+"="+encodeURIComponent(eachObject.condition+"["+eachObject.value+"]")
   })

    let responsJSON = yield call( getJobCompletion,url+extentedUrl.join("&"));
    yield put(getJobsStatusDataSuccessFull(responsJSON))
     } 
  catch (error) 
  {
    yield put(getJobsStatusDataFailed(error))
  }
} 



function*  getUpcomingInterviewsHandler({payload:{jsondata}}) {
  let pageNumeber = 0
  let pageSize = 5
  if(jsondata != undefined && jsondata != null){
    pageNumeber = jsondata.pageNumber ? jsondata.pageNumber : 0
    pageSize  = jsondata.pageSize ?  jsondata.pageSize: 5
  }
  try 
  {
    let url = constClass.REST_API_GET_DB_UPCOMING_INTERVIEWS 
    url= url+`?page=${pageNumeber}&pageSize=${pageSize}`;
    if (jsondata.sort !==null  && jsondata.sort !== undefined){
      url= url+"&sort="+encodeURIComponent(jsondata.sort)
    }

    if (jsondata.searchKeyword !==null  && jsondata.searchKeyword !== undefined){
      url= url+"&searchKeyword="+(jsondata.searchKeyword)
    }
    
    // let responsJSON = yield call(getUpcomingInterviews, url+"/"+pageNumber);
    let responsJSON = yield call(getUpcomingInterviews, url);
    yield put(getUpComingInterviewsDataSuccessFull(responsJSON))
     } 
  catch (error) 
  {
    yield put(getUpComingInterviewsDataFailed(error))
  }
} 

function* getUpcomingInterviewsFilterHandler({payload:{jsonData}}){
  let pageNumeber = 0
  let pageSize = 5
  if(jsonData.pageNumber != undefined && jsonData.pageNumber != null && jsonData.pageSize !== undefined && jsonData.pageSize !== null){
    pageNumeber = jsonData.pageNumber ? jsonData.pageNumber : 0
    pageSize  = jsonData.pageSize ?  jsonData.pageSize: 5
  }
  try 
  {
    let url= constClass.REST_API_GET_DB_FILTER_UPCOMING_INTERVIEWS+`${jsonData?.searchKeyword!== undefined && jsonData?.searchKeyword !== null && jsonData?.searchKeyword !== "" ? `?searchKeyword=${jsonData?.searchKeyword}&`: "?"}`+`page=${pageNumeber}&pageSize=${pageSize}`;   
     if (jsonData.sort !==undefined && jsonData.sort !== null){
      url= url+"&sort="+encodeURIComponent(jsonData.sort)
    }
    let extentedUrl = ""
    if(jsonData?.filter !== null && Object.entries(jsonData?.filter).length > 0){
     extentedUrl=jsonData.filter.map(eachObject=>{
      return eachObject.filterName+"="+encodeURIComponent(eachObject.condition+"["+eachObject.value+"]")
    })
  }


    if(extentedUrl !== undefined && extentedUrl !== null && extentedUrl !== ""){
      url = url+`&${extentedUrl.join("&") }`
    }

     let responsJSON = yield call(getUpcomingInterviews, url);
    yield put(getUpComingInterviewsDataSuccessFull(responsJSON))
     } 
  catch (error) 
  {
    yield put(getUpComingInterviewsDataFailed(error))
  }
} 



function* getJobCompletionhandler({payload:{eachobject}}){

  try 
  {
    let url= constClass.REST_API_GET_Job_COMPLETE_STATUS; 
    let responseJson= yield call( getJobCompletion, url+`?jobId=${eachobject.jobId}&page=${ eachobject.pagenumber}&pageSize=${ eachobject.pageSize}`);
     yield put( getJobComplitionStatusSuccessFull(responseJson))
     } 
  catch (error) 
  {
    yield put(getJobComplitionStatusFailed(error))
  }
} 

function* updateInterviewshandler({payload:{jsonData}}){
  try 
  {
    let url= constClass.REST_API_UPDATE_INTERVIEW; 
    let responseJson= yield call(postNewInterviewDetails, url, jsonData);
     yield put( updateInterviewScuccess(responseJson))
     } 
  catch (error)
  {
    if(error.includes("https:",0)){
      yield put( updateInterviewScuccess(error))
    }
    else{
    yield put(updateInterviewFail(error))
    }
  }
} 


function* upcomingInterviewsSuggestionhandler({payload:{Keyword}}){
  try 
  {
    let url= constClass.REST_API_GET_UPCOMING_INTERVIEWS_SUGGESTIONS; 
    let responseJson= yield call(getJobCompletion, url+`?size=${10}&q=${Keyword}`);
     yield put(getUpcomingInterviewsSuggestionsSuccess(responseJson))
     } 
  catch (error)

  {
    yield put(getUpcomingInterviewsSuggestionsFail(error))
  }
} 


function* jobStatusSuggestionhandler({payload:{Keyword}}){
  try 
  {
    let url= constClass. REST_API_GET_JOBSTATUS_SUGGESTIONS
    let responseJson = yield call(getJobCompletion, url+`?size=${5}&q=${Keyword}`);
     yield put(getJobStatusSuggestionsSuccess(responseJson))
  } 
  catch (error)

  {
    yield put(getJobStatusSuggestionsFail(error))
  }
} 

function* getClientJobs({payload:{data}}) {
  try 
  { 
    let url= constClass.REST_API_GET_CLIENT_JOBS; 
    if(data !== undefined && data !== null){
      url=constClass.REST_API_GET_CLIENT_JOBS+"?size="+data;
    }
    var responsJSON = yield call(getRequest, url);
    yield put(getClientJobsSuccess(responsJSON))
     } 
  catch (error) 
  {
    yield put(getClientJobsFail(responsJSON))
  }
}


function* getCandidateHired({payload:{data}}) {
  try 
  { 
    let url= constClass.REST_API_GET_CANDIDATE_HIRE; 
    if(data !== undefined && data !== null){
      url=constClass.REST_API_GET_CANDIDATE_HIRE+"?size="+data;
    }
    var responsJSON = yield call(getRequest, url);
    yield put(getCandidateHiredSuccess(responsJSON))
     } 
  catch (error) 
  {
    yield put(getCandidateHiredFail(responsJSON))
  }
}



  function* getDashboardSaga() {
    yield takeEvery (GET_PUBLISHED_JOBS, getPublishedJobsHandler);
    yield takeEvery(GET_RECRUITMENT_DATA, getRecruitmentHandler);
    yield takeEvery (GET_DASHBOARD_CARDS_DATA, getDashboardCardsHandler);
    yield takeEvery (GET_DASHBOARD_TOTALINTERVIEW_DATA, getDashboardTotalTnterviewHandler)
    yield takeEvery( GET_NEW_CANDIDATES_DATA, getDashboardTopCard); 
    yield takeEvery( GET_RECRUITMENT_REPORT, getRecruitmentReportHandler)
    yield takeEvery(GET_JOB_STATUS_DATA, getJobsStatusHandler)
    yield takeEvery( GET_JOB_STATUS_FILTER_DATA, getJobsStatusFilterHandler)
    yield takeEvery(GET_UPCOMING_INTERVIEWS_DATA, getUpcomingInterviewsHandler);
    yield takeEvery(GET_UPCOMING_INTERVIEWS_FILTER_DATA, getUpcomingInterviewsFilterHandler)
    yield takeEvery(GET_JOB_COMPLETION_STATUS, getJobCompletionhandler)
    yield takeEvery(GET_UPDATE_INTERVIEW, updateInterviewshandler)
    yield takeEvery(GET_UPCOMING_INTERVIEW_SUGGESTIONS, upcomingInterviewsSuggestionhandler)
    yield takeEvery( GET_JOBSTATUS_SUGGESTIONS, jobStatusSuggestionhandler)
    yield takeEvery( GET_CLIENT_JOBS, getClientJobs)
    yield takeEvery( GET_CANDIDATE_HIRE, getCandidateHired)
    // yield takeEvery(GET_INTERVIEW_PROCESS_MODAL_DATA, getHireModalDataHandler)
  }
  
  export default getDashboardSaga